const convertISOStringToMonthDay = date => {
    const tempDate = new Date(date).toString().split(' ');
    console.log(tempDate);
    const formattedDate = ` ${getDayTh(tempDate[0])} ${+tempDate[2]} ${getMothTh(tempDate[1])} ${+tempDate[3] + 543} ${tempDate[4]} `;
    return formattedDate;
};



const getMothTh = (month) => {
    if (month === 'Jan') {
        return 'มกราคม';
    }
    else if (month === 'Feb') {
        return 'กุมภาพันธ์';
    }
    else if (month === 'Mar') {
        return 'มีนาคม';
    }
    else if (month === 'Apr') {
        return 'เมษายน';
    }
    else if (month === 'May') {
        return 'พฤษภาคม';
    }
    else if (month === 'Jun') {
        return 'มิถุนายน';
    }
    else if (month === 'Jul') {
        return 'กรกฎาคม';
    }
    else if (month === 'Aug') {
        return 'สิงหาคม';
    }
    else if (month === 'Sep') {
        return 'กันยายน';
    }
    else if (month === 'Oct') {
        return 'ตุลาคม';
    }
    else if (month === 'Nov') {
        return 'พฤศจิกายน';
    }
    else if (month === 'Dec') {
        return 'ธันวาคม';
    }

}


const getDayTh = (day) => {
    if (day === 'Mon') {
        return 'วันจันทร์';
    }
    else if (day === 'Tue') {
        return 'วันอังคาร';
    }
    else if (day === 'Wed') {
        return 'วันพุธ';
    }
    else if (day === 'Thu') {
        return 'วันพฤหัสบดี';
    }
    else if (day === 'Fri') {
        return 'วันศุกร์';
    }
    else if (day === 'Sat') {
        return 'วันเสาร์';
    }
    else if (day === 'Sun') {
        return 'วันอาทิตย์';
    }

  

}


export default convertISOStringToMonthDay